import { getTotalHeight } from '../../utils/get_total_height'

/**
 * Adjusts the height of a container element based on the cumulative height of its child elements.
 *
 * @param {HTMLElement} contentElements - The container element whose height will be adjusted.
 */

function showNumberElements(contentElements) {
  const numberVisibleElements = parseInt(contentElements.getAttribute('data-n-visible-elements'), 10)
  const children = Array.from(contentElements.children)

  if (isNaN(numberVisibleElements) || numberVisibleElements <= 0 || children.length <= numberVisibleElements) {
    contentElements.style.height = 'auto'
    contentElements.removeAttribute('data-total-height')
    return
  }

  let heightTotal = 0
  for (let i = 0; i < numberVisibleElements; i++) {
    // Aquí getTotalHeight ya hará su propio console.log
    heightTotal += getTotalHeight(children[i])
  }

  // Add 3px of margin because some icons are larger than others.
  const MARGIN_PIXEL = 3
  contentElements.style.height = `${heightTotal - MARGIN_PIXEL}px`
  contentElements.setAttribute('data-total-height', heightTotal - MARGIN_PIXEL)
}
export function init(el) {
  const elements = el ? el : document.querySelectorAll('.js-is-truncable')

  if (!elements.length) return

  elements.forEach(elementTruncable => {
    const elementTruncated = elementTruncable.querySelector('.js-truncated')

    // check if element has content
    if (!elementTruncated) {
      return
    }

    showNumberElements(elementTruncated)

    elementTruncated.classList.add('is-truncable')
    const toggleViewMoreButton = elementTruncable?.querySelector('.js-link-see-more')
    if (toggleViewMoreButton) {
      toggleViewMoreButton.classList.remove('hidden')

      if (toggleViewMoreButton.dataset.ariaReadMore) {
        toggleViewMoreButton.setAttribute('aria-label', toggleViewMoreButton.dataset.ariaReadMore)
      }
      toggleViewMoreButton.querySelector('.js-close').classList.add('hidden')

      toggleViewMoreButton.addEventListener('click', function (e) {
        e.preventDefault()

        elementTruncated.classList.toggle('is-truncable')

        if (!elementTruncated.classList.contains('is-truncable')) {
          toggleViewMoreButton.classList.add('l-up')
          if (toggleViewMoreButton.dataset.ariaClose) {
            toggleViewMoreButton.setAttribute('aria-label', toggleViewMoreButton.dataset.ariaClose)
          }
          if (elementTruncable.classList.contains('opinion')) {
            toggleViewMoreButton.querySelector('.js-close').classList.remove('hidden')
            toggleViewMoreButton.querySelector('.js-more').classList.add('hidden')
          }
        } else {
          toggleViewMoreButton.classList.remove('l-up')
          if (toggleViewMoreButton.dataset.ariaReadMore) {
            toggleViewMoreButton.setAttribute('aria-label', toggleViewMoreButton.dataset.ariaReadMore)
          }

          if (elementTruncable.classList.contains('opinion')) {
            toggleViewMoreButton.querySelector('.js-close').classList.add('hidden')
            toggleViewMoreButton.querySelector('.js-more').classList.remove('hidden')
          }
        }

        // REB - Truncate div according to number of elements
        if (elementTruncated.getAttribute('data-total-height')) {
          if (elementTruncated.style.height !== '100%') {
            elementTruncated.style.height = '100%'
          } else {
            const totalHeight = elementTruncated.getAttribute('data-total-height')
            elementTruncated.style.height = `${totalHeight}px`
          }
        }
      })
    }
  })
}

window.IB.truncable = {
  init,
}

IB.truncable.init()
